import { render, staticRenderFns } from "./AuthChoose.vue?vue&type=template&id=af9aa892&scoped=true"
import script from "./AuthChoose.vue?vue&type=script&lang=js"
export * from "./AuthChoose.vue?vue&type=script&lang=js"
import style0 from "./AuthChoose.vue?vue&type=style&index=0&id=af9aa892&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af9aa892",
  null
  
)

export default component.exports